import React from "react";
import CallToAction from "../components/CallToAction";
import TeamLeaderItem from "../components/team-leader-item";
import Link from "gatsby-link";
import styles from "../styles/team.module.scss";
import Img from "gatsby-image";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet";

const ProfilePage = ({ transition, pathContext, data, location }) => {
	const { profile } = data;
	const cta = data.cta.edges[0].node;
	return (
		<PageWrapper
			locale={profile.node_locale}
			location={location}
			data={data.layout.edges[0].node}
		>
			<main role="main" style={transition && transition.style}>
				<Helmet
					title={
						profile.fullName +
						" | " +
						(profile.node_locale === "th" ? "ทีม" : "Team") +
						" | Mahidol Vivax Research Unit"
					}
					meta={[
						{
							name: "description",
							content: profile.shortBio.content
						},
						{
							name: "keywords",
							content:
								"malaria, vivax, mahidol, tropical medicine, lab, laboratory"
						},
						{
							name: "og:title",
							content:
								profile.fullName +
								" | " +
								(profile.node_locale === "th"
									? "ทีม"
									: "Team") +
								" | Mahidol Vivax Research Unit"
						},
						{
							name: "og:description",
							content: profile.shortBio.content
						},
						{
							name: "og:image",
							content: profile.profilePicture.sizes.src
						}
					]}
				/>
				<div
					id="navColorReference"
					style={{ background: "white" }}
					className={"container mt-5 mb-1 " + styles.go_back}
				>
					<div>
						<Link to={`/${profile.node_locale}/team`}>
							&laquo;{" "}
							{profile.node_locale === "th"
								? "กลับไปที่หน้าทีม"
								: "Go back to Team page"}
						</Link>
					</div>
				</div>

				<div
					className={"grey_bg pb-5"}
					style={{ position: "relative" }}
				>
					<div className={"white_bg"}>
						<div className="container ">
							<div className={styles.wide_row}>
								<TeamLeaderItem
									locale={profile.node_locale}
									photo={profile.profilePicture.sizes.src}
									job_title={profile.jobTitle}
									researchInterests={
										profile.researchInterests
									}
									name={profile.fullName}
									degree={profile.academicDegree}
									bio={profile.shortBio.content}
									email={profile.email}
									pubMed={profile.pubMedPublications}
									researchGate={profile.researchGateUrl}
									mahidolProfile={profile.mahidolProfileUrl}
									linkedInProfile={profile.linkedInUrl}
								/>
							</div>
						</div>
					</div>
					<div className={"container "}>
						{profile.grantsHistory && (
							<div
								className={
									styles.wide_row +
									" justify-content-between " +
									styles.career_list
								}
							>
								<div className="col-12 mb-3">
									<h3>Grants history</h3>
								</div>
								{profile.grantsHistory &&
									profile.grantsHistory.map((item, ixx) => {
										return (
											<CareerRow
												key={"history-" + ixx}
												logo={item.funderLogo}
												funder={item.funderName}
												description={item.title}
												when={item.date}
											/>
										);
									})}
							</div>
						)}
						{profile.project && (
							<div
								className={
									styles.wide_row + " " + styles.career_list
								}
							>
								<div className="col-12 mb-3">
									<h3>Collaborations</h3>
								</div>
								{profile.project &&
									profile.project.map((item, ixx) => {
										return (
											<CareerRow
												key={"history-" + ixx}
												logo={
													item.funders &&
													item.funders[0].logo
												}
												funder={
													item.funders &&
													item.funders[0].name
												}
												description={item.title}
												when={item.date}
											/>
										);
									})}
							</div>
						)}

						{profile.awards && (
							<div
								className={
									styles.wide_row + " " + styles.career_list
								}
							>
								<div className="col-12 mb-3">
									<h3>Awards</h3>
								</div>

								{profile.awards &&
									profile.awards.map((item, ixx) => {
										return (
											<CareerRow
												key={"history-" + ixx}
												description={item.title}
												when={item.date}
											/>
										);
									})}
							</div>
						)}
					</div>
				</div>

				<CallToAction
					className="my-5"
					leadText={cta.leadingText}
					text={cta.content.childMarkdownRemark.html}
					buttonLabel={cta.buttonLabel}
					destination={`/${profile.node_locale}${cta.linkTo}`}
					arrow={true}
				/>
			</main>
		</PageWrapper>
	);
};

export default ProfilePage;

const CareerRow = ({ logo, description, when, funder }) => (
	<div className="col-12 py-3">
		<div className={"row align-items-center " + styles.career_row}>
			<div className="col-8 col-md-3 text-center">
				{logo && <Img title={funder} alt={funder} sizes={logo.sizes} />}
			</div>
			<div className="col-12 col-md-7 ">{description}</div>
			<div className="col-12  col-md-2 text-center">{when}</div>
		</div>
	</div>
);

export const pageQuery = graphql`
	query ProfileQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		profile: contentfulPrincipalInvestigators(id: { eq: $id }) {
			academicTitle
			fullName
			jobTitle
			academicDegree
			email
			pubMedPublications
			researchGateUrl
			linkedInUrl
			mahidolProfileUrl
			researchInterests {
				title
				slug
			}
			profilePicture {
				sizes {
					src
				}
			}
			grantsHistory {
				title
				date
				funderName
				funderLogo {
					sizes(maxHeight: 250, quality: 85, resizingBehavior: PAD) {
						base64
						aspectRatio
						src
						srcSet
						srcWebp
						srcSetWebp
						sizes
					}
				}
			}
			project {
				title
				date
				funders {
					name
					logo {
						sizes(
							maxHeight: 250
							quality: 85
							resizingBehavior: PAD
						) {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
				}
			}
			awards {
				title
				date
			}
			shortBio {
				content: childMarkdownRemark {
					html
				}
			}

			node_locale
			slug
		}

		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "team" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/profile-template.js